import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Settings from "@/pages/Settings";
import TradeHistory from "@/pages/TradeHistory";
import Analytics from "@/pages/Analytics";
import Backtest from "@/pages/Backtest";

import { AuthProvider, useAuth } from "@/context/AuthContext";
import { BotProvider } from "@/context/BotContext";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading, subscriptionOk, logout } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: 'var(--bg-primary)' }}>
        <div style={{ color: 'var(--accent-teal)' }} className="font-medium text-sm">Loading...</div>
      </div>
    );
  }
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (!subscriptionOk) {
    return (
      <div className="min-h-screen flex items-center justify-center p-4" style={{ background: 'var(--bg-primary)' }}>
        <div className="max-w-md text-center space-y-4">
          <div className="text-lg font-bold" style={{ color: 'var(--accent-red)' }}>Subscription Expired</div>
          <p className="text-sm" style={{ color: 'var(--text-secondary)' }}>Your Whop subscription is no longer active. Renew to continue using Edge Bot.</p>
          <div className="flex gap-3 justify-center">
            <a href="https://whop.com/probability-lab/4751/" target="_blank" rel="noopener noreferrer"
              className="btn-primary inline-flex items-center justify-center">
              Renew Subscription
            </a>
            <button onClick={logout} className="btn-secondary px-4 py-2 text-xs font-semibold uppercase">
              Logout
            </button>
          </div>
        </div>
      </div>
    );
  }
  return children;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
      <Route path="/history" element={<ProtectedRoute><TradeHistory /></ProtectedRoute>} />
      <Route path="/analytics" element={<ProtectedRoute><Analytics /></ProtectedRoute>} />
      <Route path="/backtest" element={<ProtectedRoute><Backtest /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BotProvider>
        <BrowserRouter>
          <Toaster
            position="top-right"
            toastOptions={{
              style: {
                background: 'var(--bg-card)',
                border: '1px solid var(--border)',
                color: 'var(--text-primary)',
                fontFamily: 'Inter, sans-serif',
                fontSize: '13px',
                borderRadius: '10px',
              },
            }}
          />
          <AppRoutes />
        </BrowserRouter>
      </BotProvider>
    </AuthProvider>
  );
}

export default App;
